import React from 'react'
import LazyLoad from 'react-lazyload'

const lazyOffset = 500
const imgBaseUrl = 'https://res.cloudinary.com/emilbruckner/image/upload/'
const imgParams = 'c_fill,f_auto,q_67'

const Component = React.createClass({
  getInitialState: function() {
    return {
      height: 1000,
      isLoaded: false
    }
  },
  handleImageLoaded: function() {
    this.setState({isLoaded: true})
  },
  getImageSize: function() {
    return image
  },
  updateDimensions: function() {
      this.setState({height: window.innerHeight});
  },
  componentDidMount: function() {
    this.updateDimensions()
    window.addEventListener("resize", this.updateDimensions);
  },
  componentWillUnmount: function() {
      window.removeEventListener("resize", this.updateDimensions);
  },
  render: function() {
    const vh = this.state.height
    const vw = this.props.maxWidth
    const aspectRatio = this.props.aspectRatio
    // todo: test: document.getElementById('container').clientWidth
    // todo: remove vw from parent (Person.js)
    const desiredWidth = vw * this.props.width
    const maxHeight = vh * this.props.width * 1.15

    let imageWidth = desiredWidth
    let imageHeight = imageWidth / aspectRatio 

    if (imageHeight >= maxHeight) {
      imageHeight = maxHeight
      imageWidth = imageHeight * aspectRatio
    }

    const image = {
      style: {
        ...this.props.style,
        maxHeight: imageHeight,
        // maxWidth: '90vw',
        backgroundColor: '#dddddd',
        height: this.state.isLoaded ? '' : imageHeight,
        width: imageWidth,
        // opacity: this.state.isLoaded ? 1 : 0.5,
        // transition: 'opacity 0.3s'
      },
      dimensions: {
        height: imageHeight,
        width: imageWidth
      }
    }
    const pixelRatio = 1.3
    // const pixelRatio = window ? window.devicePixelRatio || 1 : 1.3
    const downloadWidth = 100 * Math.ceil(image.dimensions.width * pixelRatio / 100)
    const downloadHeight = Math.round(downloadWidth / this.props.aspectRatio)
    return (
      <LazyLoad height={image.dimensions.height} style={image.style} offset={lazyOffset}>
        <img
          style={image.style}
          onLoad={this.handleImageLoaded}
          src={`${imgBaseUrl + imgParams},w_${downloadWidth},h_${downloadHeight}/${this.props.imgId}`}
          alt={this.props.alt}/>
      </LazyLoad>
    )
  }
})

export default Component


// className={this.state.loaded ? 'image, image-loaded' : 'image'}
// onLoad={this.onImageLoad}



// WEBPACK FOOTER //
// ../components/Image.js